import { render, staticRenderFns } from "./category-manage-modal.vue?vue&type=template&id=e635126c&scoped=true&"
import script from "./category-manage-modal.vue?vue&type=script&lang=js&"
export * from "./category-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e635126c",
  null
  
)

export default component.exports